export const addChallangeAIWizardText = {
  title: 'Challenge branch AI',
  generatedQuestion: 'Generated question:',
  result: 'This is your results',
  add: 'Insert into lesson',
  regenerate: 'Regenerate',
};
